<template>
  <div class="wrapper">
    <Header class="header" :val="'렌탈'" @rental="rental" :type="'orderMain'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="fullH transparent landing rental">
        <section class="landingVisual beginer bg01">
          <div class="inner">
            <p class="desc">쉽고 빠른 웰몰의 렌탈</p>
            <p class="copy">
              <strong>3단계</strong>
              만의
              <br />
              <strong class="txtLine">렌탈완료</strong>
            </p>
          </div>
          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="goNextDepth">시작하기</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
      <ConfirmPop v-if="confirmPop" @confirm="confirm" @cancel="cancel" @close="confirmPop = false">
        <p v-html="msg"></p>
      </ConfirmPop>
    </div>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import ConfirmPop from '@/components/popup/ConfirmPop';
import { GO_HOME } from '@/store/message.type.js';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'MemberMain',
  components: {
    ConfirmPop,
  },
  data() {
    return {
      orderId: '',
      prodCode: '',
      couponId: '',
      couponSerialNumber: '',
      //colorCode: this.$route.params.colorCode,

      confirmPop: false,
      msg: '',

      paramObj: {
        request: {
          conOrderInfo: {
            cellNum: '',
            conAddrCode: '',
            conAddrJibun: '',
            conAddrPost: '',
            conAddrRemark: '',
            conAddrRoad: '',
            customerName: '',
            localUserYn: '',
            sex: '',
            ssn: '',
            userIdentityComp: '',
          },
          installInfo: {
            installAddrCode: '',
            installAddrJibun: '',
            installAddrPost: '',
            installAddrRemark: '',
            installAddrRoad: '',
            installCellNum: '',
            installReqDate: '',
            installUserName: '',
          },
          joinInfo: {
            joinYn: 'N',
            password: '',
            selectedAgree3: '',
            userId: '',
          },
          orderCommInfo: {
            colorCode: '',
            internalProdCode: '',
            orderId: '',
            orderStatus: 'RSTA00PR',
            safekey: '',
            saleType: 'RORT00GE',
            creditKey: '',
            requestKey: '',
          },
          payInfo: {
            bankAccnt: '',
            bankCode: '',
            cardExpireDate: '',
            cardName: '',
            cardNumber: '',
            cashNum: '',
            cashReqYn: '',
            checkType: '',
            couponCd: '',
            couponTitle: '',
            dueDate: '',
            rmanCd: '',
            secureKeyPad: '',
          },
          selectAgreeInfo: {
            agreeAppPush: '',
            agreeCollection: '',
            agreeCredit: '',
            agreeDm: '',
            agreeEmail: '',
            agreeSms: '',
            agreeTel: '',
          },
        },
        serviceType: 'app',
      },
      paramOrderId: this.$route.params.orderId,
    };
  },
  created() {
    const orderCommInfo = this.$route.params.orderCommInfo;
    console.log(orderCommInfo);
    if (orderCommInfo != null) {
      this.prodCode = orderCommInfo.productCode;
      this.paramObj.request.orderCommInfo.colorCode = orderCommInfo.colorCode;
      this.paramObj.request.orderCommInfo.internalProdCode = orderCommInfo.internalProdCode;
    } else {
      this.prodCode = this.$route.params.productCode;
      this.couponId = this.$route.params.coupon;
      this.couponSerialNumber = this.$route.params.couponSerialNumber;
      this.paramObj.request.orderCommInfo.colorCode = this.$route.params.colorCode;
      this.paramObj.request.orderCommInfo.internalProdCode = this.$route.params.internalProdCode;
    }
  },
  mounted() {
    if (!isEmpty(this.paramOrderId)) {
      this.paramObj.request.orderCommInfo.orderId = this.paramOrderId;
    }
  },
  methods: {
    goNextDepth() {
      if (
        this.paramObj.request.orderCommInfo.orderId != null &&
        this.paramObj.request.orderCommInfo.orderId != undefined &&
        this.paramObj.request.orderCommInfo.orderId != ''
      ) {
        // 주문서 이어하기
        this.$router.push({
          name: 'memberRentalTerm',
          params: { paramObj: this.paramObj, prodCode: this.prodCode, couponId: this.couponId, couponSerialNumber: this.couponSerialNumber },
        });
      } else {
        ApiService.service('GET', '/order/id')
          .then(({ data }) => {
            if (data.isSucceed) {
              this.paramObj.request.orderCommInfo.orderId = data.result;
              this.$router.push({
                name: 'memberRentalTerm',
                params: { paramObj: this.paramObj, prodCode: this.prodCode, couponId: this.couponId, couponSerialNumber: this.couponSerialNumber },
                //params: { paramObj: this.paramObj, prodCode: this.prodCode, couponId: this.couponId, colorCode: this.colorCode },
              });
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });
      }
    },
    rental() {
      this.msg = GO_HOME;
      this.confirmPop = true;
    },
    cancel() {
      this.confirmPop = false;
    },
    confirm() {
      this.$router.replace('/');
    },
  },
};
</script>
